/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect, useState } from "react";

import { useFormContext } from "react-hook-form";

import { Card } from "@origin-digital/ods-core";
import { task } from "@origin-digital/reporting-client";

import { RouterActions } from "@/components";
import { PreloaderScreen } from "@/components/PreloaderScreen";
import { ANALYTICS_FORM_NAME, ANALYTICS_TASK_TYPE } from "@/constants";
import { BatteryNotSupported } from "@/features/BatteryOutlook/BatteryNotSupported";
import { BatterySupported } from "@/features/BatteryOutlook/BatterySupported";
import { useBatteryOutlook } from "@/features/BatteryOutlook/useBatteryOutlook";

import { batteryOutlook as content } from "../SolarForm/content.json";

export const BatteryOutlook = memo(
  ({
    batteryNextRoute,
    batteryBackRoute,
  }: {
    batteryNextRoute: () => Promise<string>;
    batteryBackRoute: () => Promise<string>;
  }) => {
    const { loading, batteryOutlook } = useBatteryOutlook();
    const [showPreloader, setShowPreloader] = useState(true);
    const { getValues } = useFormContext();

    const isBatterySupported =
      batteryOutlook.data &&
      batteryOutlook.data.batteryData &&
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      batteryOutlook.data.currentExcessExport! >= 5;

    let body = null;
    if (batteryOutlook.data) {
      body = isBatterySupported ? (
        <BatterySupported batteryOutlook={batteryOutlook.data} />
      ) : (
        <BatteryNotSupported batteryOutlook={batteryOutlook.data} />
      );
    }

    // Hide preloader and show content once loading is completed, and data is available
    useEffect(() => {
      const batteryOutlookData = batteryOutlook.data;
      const systemType = getValues("systemType");
      if (!loading && batteryOutlookData) {
        setShowPreloader(false);
        task.base(ANALYTICS_TASK_TYPE, {
          action: "update",
          formName: ANALYTICS_FORM_NAME,
          currentAction: {
            batterySize: batteryOutlookData.batteryData?.at(-1)?.batterySize,
            systemType,
          },
        });
      }
    }, [loading, batteryOutlook.data]);

    return (
      <Card paddingXSpecific="xlarge">
        {showPreloader ? (
          <PreloaderScreen
            id={content.batteryOutlookPreloader.id}
            heading={content.batteryOutlookPreloader.heading}
            description={content.batteryOutlookPreloader.description}
          />
        ) : (
          <>
            {body}
            <RouterActions
              onBackRoute={batteryBackRoute}
              onNextRoute={batteryNextRoute}
              nextLabel="Next"
            />
          </>
        )}
      </Card>
    );
  }
);
